import { Routes, Route } from "react-router-dom";
import RecurringList from "./RecurringList";
import RecurringForm from "./RecurringForm";


export default function Recurring(){
return (
<Routes>
<Route path="/" element={<RecurringList/>} />
<Route path="new" element={<RecurringForm/>} />
</Routes>
);
}